import React from 'react';

type Props = {
  collapsing?: boolean;
  thin?: boolean;
  children?: React.ReactNode;
  stackable?: boolean; // Table header cells are hidden on small devices
  textAlign?: 'left' | 'right' | 'center';
  colSpan?: number;
};

function TableHeadCell({ collapsing, thin, children, textAlign = 'left', stackable = true, colSpan }: Props) {
  const classNames = [
    'text-left',
    'text-xs',
    'font-medium',
    'text-gray-600',
    'uppercase',
    'tracking-wider',
    'whitespace-nowrap',
  ];

  if (thin) {
    classNames.push('px-3', 'py-3');
  } else {
    classNames.push('px-6', 'py-3');
  }

  if (stackable) {
    classNames.push('md:table-cell', 'hidden');
  }

  switch (textAlign) {
    case 'left':
      classNames.push('text-left');
      break;
    case 'center':
      classNames.push('text-center');
      break;
    case 'right':
      classNames.push('text-right');
      break;
    default:
      break;
  }

  if (collapsing) {
    classNames.push('max-w-min');
  }

  return (
    <th scope="col" className={classNames.join(' ')} colSpan={colSpan}>
      {children}
    </th>
  );
}

export default TableHeadCell;
